module.exports = __webpack_public_path__ + "static/media/rugDying.ee925160.png";